export default __webpack_public_path__ + "fonts/kingvision_logo.7930e80e315096159bdc1dca8e8ec1e8.png";